"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _clampJs = _interopRequireDefault(require("clamp-js"));
var _hooks = require("../hooks");
var _styles = require("./styles");
var _keydownEvents = require("../utils/keydown-events");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MediaThumbnail = function MediaThumbnail(_ref) {
  var src = _ref.src,
    srcSet = _ref.srcSet,
    sizes = _ref.sizes,
    mediaType = _ref.mediaType,
    caption = _ref.caption,
    selected = _ref.selected,
    remaining = _ref.remaining,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    onFocus = _ref.onFocus,
    showSkeleton = _ref.showSkeleton,
    onImageLoaded = _ref.onImageLoaded,
    ariaLabel = _ref.ariaLabel;
  var theme = (0, _hooks.useTheme)();
  var captionRef = (0, _react.useRef)(null);
  var onClickEnterKeyDown = (0, _keydownEvents.createOnClickEnterKeyDown)(onClick);
  (0, _react.useEffect)(function () {
    if (captionRef && captionRef.current) {
      (0, _clampJs["default"])(captionRef.current, {
        clamp: 3
      });
    }
  }, [captionRef]);
  var common = /*#__PURE__*/_react["default"].createElement(_styles.ThumbnailBase, {
    selected: selected,
    onClick: onClickEnterKeyDown,
    onKeyDown: onClickEnterKeyDown,
    onMouseEnter: onMouseEnter,
    showSkeleton: showSkeleton,
    "aria-label": ariaLabel,
    onFocus: onFocus,
    tabIndex: "0"
  }, /*#__PURE__*/_react["default"].createElement(_styles.ThumbnailInner, null, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "",
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    onLoad: onImageLoaded
  }), mediaType === 'VIDEO' && /*#__PURE__*/_react["default"].createElement(_styles.PlayIcon, null)), remaining > 0 && /*#__PURE__*/_react["default"].createElement(_styles.Remaining, null, /*#__PURE__*/_react["default"].createElement("span", null, "+", remaining)), caption && /*#__PURE__*/_react["default"].createElement(_styles.ThumbnailCaption, {
    ref: captionRef
  }, caption));
  return (theme === null || theme === void 0 ? void 0 : theme.scheme) === 'nucleus' ? common : /*#__PURE__*/_react["default"].createElement(_styles.ClassicThumbnailRoot, {
    selected: selected
  }, common);
};
MediaThumbnail.propTypes = {
  src: _propTypes["default"].string.isRequired,
  srcSet: _propTypes["default"].string,
  sizes: _propTypes["default"].string,
  mediaType: _propTypes["default"].oneOf(['IMAGE', 'VIDEO', 'skeleton', 'LPSURROUND']),
  caption: _propTypes["default"].string,
  selected: _propTypes["default"].bool,
  remaining: _propTypes["default"].number,
  onClick: _propTypes["default"].func,
  onMouseEnter: _propTypes["default"].func,
  showSkeleton: _propTypes["default"].bool,
  onImageLoaded: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  ariaLabel: _propTypes["default"].string
};
MediaThumbnail.defaultProps = {
  srcSet: undefined,
  sizes: undefined,
  mediaType: 'IMAGE',
  caption: '',
  selected: false,
  remaining: -1,
  onClick: _noop["default"],
  onMouseEnter: _noop["default"],
  showSkeleton: false,
  onImageLoaded: _noop["default"],
  onFocus: _noop["default"],
  ariaLabel: ''
};
var _default = MediaThumbnail;
exports["default"] = _default;
//# sourceMappingURL=_Thumbnail.js.map